












import Vue from "vue";
import { Component } from "vue-property-decorator";

/**
 * Error page.
 */
@Component
export default class ErrorPage extends Vue {
	goToPreviousPage() {
		window.location.href = document.referrer;
	}
	goToHomePage() {
		window.location.href = "/teams";
	}
}
